import React from 'react';

import { RestrictedShipmentBannerMessage } from './restricted-shipment-banner-message';
import { useEnhancedGlobalEConfig } from '../../feature-flags/hooks/use-enhanced-global-e-config';
import { useIsTikTokShippingOrder } from '../hooks/use-is-tiktok-shipping-order';
import GlobalEMessage from './global-e-message';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {JSX.Element} props.Config
 * @returns {JSX.Element}
 */
export const RestrictedShipmentSection = ({ fulfillmentPlanId, Config }) => {
  const shouldEnhanceFf = useEnhancedGlobalEConfig();
  const isTikTokShipping = useIsTikTokShippingOrder(fulfillmentPlanId);

  return (
    <Config
      AdditionalContent={isTikTokShipping ? null : GlobalEMessage}
      fulfillmentPlanId={fulfillmentPlanId}
      isTikTokShipping={isTikTokShipping}
      RestrictedBanner={isTikTokShipping ? null : RestrictedShipmentBannerMessage}
      showEnhancedConfig={shouldEnhanceFf || isTikTokShipping}
    />
  );
};
